export default {
    "superadmin": "Суперадмин",
    "admin": "HR Администратор",
    "staff": "Сотрудник",
    "private_person": "Частное лицо",
    'hr_department': 'HR подразделения'
}